import Vue from "vue";
import moment from "moment";
import { Component, Prop } from "vue-property-decorator";
import {
  FORMAT_DATE_EN,
  FORMAT_DATE_FR,
  FORMAT_DATE_NL
} from "../../common/constants";

@Component({
  template: require("./template.html")
})
class LabelDateTimeFormattedComponent extends Vue {
  @Prop({ default: "date" })
  type: string;

  @Prop({ default: null })
  format: string;

  @Prop({ required: true, type:[Object, Array, String]})
  value;

  _value: Date;
  _format: string;

  get FormattedDate() {
    var locale = moment.locale();

    if (this.format) {
      this._format = this.format;
    } else {
      if (locale == "fr") {
        this._format = FORMAT_DATE_FR;
      } else if (locale == "nl") {
        this._format = FORMAT_DATE_NL;
      } else {
        this._format = FORMAT_DATE_EN;
      }
    }

    if (this.value ===  undefined || this.value === null) {
       return "";
    }
    else if (typeof this.value === "string") {
      this._value = moment(this.value).toDate();
    } else {
      this._value = this.value;
    }

    return moment(this._value).format(this._format);
  }

  beforeDestroy(){
    this._value = null;
    this._format = null;
  }
}

export default LabelDateTimeFormattedComponent;
